module.exports = __webpack_public_path__ + "static/draftking-banner-1af4ddf9f8fddaece31a0753211d9112.png";